import { AutogenLayoutFuelReimbursementRateList } from "./autogen/AutogenLayoutFuelReimbursementRateList";

export class FuelReimbursementRateList extends AutogenLayoutFuelReimbursementRateList {
    onLoad(): void | Promise<void> {
        this.sourceFuelReimbursement.orderBy = [{ field: "id", sort: "asc" }];
    }
}
